export default function TrustBar() {
  const features = [
    {
      icon: 'ri-parent-line',
      text: 'Educación 0-3 años'
    },
    {
      icon: 'ri-shield-check-line',
      text: 'Homologados por la Comunidad de Madrid'
    },
    {
      icon: 'ri-heart-3-line',
      text: 'Educadores con vocación'
    },
    {
      icon: 'ri-home-heart-line',
      text: 'Ambiente familiar y seguro'
    }
  ];

  return (
    <section className="bg-[#A8C5B0]/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#A8C5B0] rounded-full mb-4">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <p className="text-gray-800 font-medium">{feature.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
